import { EventType } from './event-type.interface';

export const GARAGE: EventType = {
  name: 'Garage',
  description: 'When a Garage Door opens or closes',
  route: 'garage',
  category: 'Security & Access',
  icon: 'garage',
  whitelist: [
    {
      proxy: 'contactsingle_garagedoorsensor_c4',
      events: [1, 2]
    },
    {
      proxy: 'relaycontact_garagedoor_c4',
      events: [1, 2]
    },
    {
      proxy: 'relaysingle_garagedoor_c4',
      events: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/garage.type.ts